import { render, staticRenderFns } from "./SystemActionItem.vue?vue&type=template&id=2375b6ce"
import script from "./SystemActionItem.vue?vue&type=script&lang=js"
export * from "./SystemActionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports